export const TYPES = {
  NOT_EMPTY: "not-empty",
  EMAIL: "email",
  ITEM_BLOCK: "item-block",
  DATE_GREATER_THAN: "date-greater-than",
  DATE_GREATER_THAN_IF_VALUE_EXISTS: "date-greater-than-if-value-exists"
};

export const EMPTY_ERRORS = { valid: true, description: "" };
